var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","small":!_vm.isMobile(),"height":"30","color":"info","depressed":"","block":_vm.isMobile()},on:{"click":function($event){return _vm.addExperiencia()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v("Adicionar experiência ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }